import { Box, Typography } from "./Mui";

export function Why() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        "@media(max-width: 640px)": {
          flexDirection: "column",
          gap: "40px 0",
          justifyContent: "flex-start",
          alignItems: "center",
        },
      }}
    >
      <Box>
        <Typography
          sx={{
            color: "text.primary",
            fontSize: "50px",
            fontWeight: 800,
            width: "100%",
            maxWidth: "447px",
          }}
        >
          Why Choose Poki Wallet?
        </Typography>

        <Box sx={{ margin: "56px 0 0 0" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "40px 0" }}>
            <Box sx={{ display: "flex", gap: "0 8px", overflow: "hidden" }}>
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  background: "#28BF5B",
                  borderRadius: "50%",
                  margin: "10px 0 0 0",
                }}
              />

              <Box>
                <Typography
                  sx={{
                    color: "text.primary",
                    fontSize: "18px",
                    fontWeight: 800,
                  }}
                >
                  100% Decentralized
                </Typography>

                <Typography
                  sx={{
                    color: "text.secondary",
                    margin: "4px 0 0 0",
                    fontSize: "14px",
                    width: "100%",
                    maxWidth: "500px",
                  }}
                >
                  Assets and data are fully controlled by users, with no need to
                  trust third parties.
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "0 8px", overflow: "hidden" }}>
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  background: "#28BF5B",
                  borderRadius: "50%",
                  margin: "10px 0 0 0",
                }}
              />

              <Box>
                <Typography
                  sx={{
                    color: "text.primary",
                    fontSize: "18px",
                    fontWeight: 800,
                  }}
                >
                  100% Open Source
                </Typography>

                <Typography
                  sx={{
                    color: "text.secondary",
                    margin: "4px 0 0 0",
                    fontSize: "14px",
                    width: "100%",
                    maxWidth: "500px",
                  }}
                >
                  100% Open Source, ensuring transparency, community
                  collaboration, and trust in every aspect of development.
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "0 8px", overflow: "hidden" }}>
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  background: "#28BF5B",
                  borderRadius: "50%",
                  margin: "10px 0 0 0",
                }}
              />

              <Box>
                <Typography
                  sx={{
                    color: "text.primary",
                    fontSize: "18px",
                    fontWeight: 800,
                  }}
                >
                  Gas-Free Experience
                </Typography>

                <Typography
                  sx={{
                    color: "text.secondary",
                    margin: "4px 0 0 0",
                    fontSize: "14px",
                    width: "100%",
                    maxWidth: "500px",
                  }}
                >
                  Compared to networks like Ethereum, Poki Wallet offers
                  lower-cost token transactions and file storage.
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "0 8px", overflow: "hidden" }}>
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  background: "#28BF5B",
                  borderRadius: "50%",
                  margin: "10px 0 0 0",
                }}
              />

              <Box>
                <Typography
                  sx={{
                    color: "text.primary",
                    fontSize: "18px",
                    fontWeight: 800,
                  }}
                >
                  All-in-One Management for Files and Tokens
                </Typography>

                <Typography
                  sx={{
                    color: "text.secondary",
                    margin: "4px 0 0 0",
                    fontSize: "14px",
                    width: "100%",
                    maxWidth: "500px",
                  }}
                >
                  One wallet for all your asset management needs.
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "0 8px", overflow: "hidden" }}>
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  background: "#28BF5B",
                  borderRadius: "50%",
                  margin: "10px 0 0 0",
                }}
              />

              <Box>
                <Typography
                  sx={{
                    color: "text.primary",
                    fontSize: "18px",
                    fontWeight: 800,
                  }}
                >
                  Simple Interaction, Easy to Use.
                </Typography>

                <Typography
                  sx={{
                    color: "text.secondary",
                    margin: "4px 0 0 0",
                    fontSize: "14px",
                    width: "100%",
                    maxWidth: "500px",
                  }}
                >
                  Perfect for Web3 newbies & pros, offering a smoother
                  experience.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ position: "relative" }}>
        <img src="/images/phone-wallet.svg" alt="" />

        {/* <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "63px",
            height: "197px",
            background: "#85FFAE",
            filter: "blur(127px)",
            zIndex: -1,
          }}
        /> */}

        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: -1,
          }}
        >
          <img src="/images/phone-blur.svg" alt="" />
        </Box>
      </Box>
    </Box>
  );
}
